export const globalServicesManager = {
  header: {
    title: "Serviços e experiências",
    description: "Uma só lista para toda a sua conta. Escreva cada serviço uma vez e marque em que anúncios é oferecido.",
  },

  toolbar: {
    info: "O que criar aqui aparece no seu <strong>motor de reservas</strong> e no seu <strong>site</strong>, nos anúncios que marcar.",
    newService: "Novo serviço",
  },

  loading: "A carregar serviços…",

  empty: {
    title: "Ainda não tem serviços",
    description: "Um transfer, uma visita guiada, um cabaz de boas-vindas… O hóspede adiciona-os ao reservar.",
    create: "Criar o primeiro",
  },

  status: {
    active: "Ativo",
    paused: "Em pausa",
  },

  price: {
    onRequest: "Sob consulta",
    free: "Grátis",
  },

  assign: {
    title: "Em que anúncios é oferecido",
    listingsLabel: "Os seus anúncios",
    selectAll: "Selecionar todos",
    clearAll: "Limpar todos",
    inAll: "Em todos os anúncios",
    inSome: "Em {n} de {total}",
    units: "{n} unidades",
    pickRooms: "Escolher quartos",
    hideRooms: "Ocultar quartos",
    roomsHint: "Marque só os quartos onde é oferecido. Sem marcar nenhum, é oferecido em todos.",
    inRooms: "Em 1 quarto | Em {count} quartos",
    unassigned: "Sem atribuição",
    helperNone: "Sem marcar nada, este serviço NÃO é oferecido em lado nenhum.",
    roomsChecked: "1 marcado · limpar | {count} marcados · limpar",
    andMore: "+1 mais | +{count} mais",
    helper: "Sem marcar nenhum, o serviço é oferecido em todos os seus anúncios.",
  },

  actions: {
    edit: "Editar",
    delete: "Eliminar",
    cancel: "Cancelar",
    save: "Guardar",
  },

  delete: {
    title: "Eliminar o serviço",
    text: "«{name}» deixará de ser oferecido em todos os anúncios. Não pode ser desfeito.",
    accept: "Sim, eliminar",
  },

  saved: {
    assign: "Anúncios atualizados",
    state: "Serviço atualizado",
    deleted: "Serviço eliminado",
  },

  errors: {
    load: "Não conseguimos carregar os seus serviços.",
    assign: "Não conseguimos guardar os anúncios.",
    state: "Não conseguimos alterar o serviço.",
    delete: "Não conseguimos eliminar o serviço.",
  },
};
